import React from "react";
import "./Pagination.scss";
import arrow from "../../assets/arrow-black.svg"
const Pagination = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const getPages = () => {
        if (totalPages <= 4) return Array.from({ length: totalPages }, (_, i) => i + 1);

        const pages = [1];

        if (currentPage > 3) pages.push("...");

        if (currentPage > 2 && currentPage < totalPages - 1) pages.push(currentPage - 1);
        if (currentPage > 1 && currentPage < totalPages) pages.push(currentPage);
        if (currentPage < totalPages - 1) pages.push(currentPage + 1);

        if (currentPage < totalPages - 2) pages.push("...");

        pages.push(totalPages);

        return pages;
    };

    return (
        <div className="custom-pagination">
            <button
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="custom-pagination__button"
            ><img alt="" src={arrow} className="left-arr" />
            </button>

            {getPages().map((page, index) => (
                <button
                    key={index}
                    onClick={() => typeof page === "number" && onPageChange(page)}
                    className={`custom-pagination__button ${currentPage === page ? "active" : ""}`}
                    disabled={page === "..."}
                >
                    {page}
                </button>
            ))}

            <button
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="custom-pagination__button"
            >
                <img alt="" src={arrow} className="right-arr" />
            </button>
        </div>
    );
};

export default Pagination;
